/* Climate Flow quote form: turns the fieldsets into steps. Without JavaScript every field shows at once. */
class CfQuoteForm extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    if (!this.form) return;
    this.steps = [...this.querySelectorAll('[data-step]')];
    this.prefill();
    this.form.addEventListener('change', (event) => {
      if (event.target.name === 'contact[Urgency]') this.toggleEmergency();
    });
    this.form.addEventListener('submit', () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'cf_quote_submit',
        cf_service: this.value('contact[Service]'),
        cf_urgency: this.value('contact[Urgency]'),
        cf_property: this.value('contact[Property]'),
      });
    });
    this.toggleEmergency();
    if (this.steps.length < 2 || this.dataset.posted === 'true') return;

    this.classList.add('is-stepped');
    this.counter = this.querySelector('[data-step-counter]');
    this.bar = [...this.querySelectorAll('[data-step-bar] span')];
    this.back = this.querySelector('[data-step-back]');
    this.next = this.querySelector('[data-step-next]');
    this.submit = this.querySelector('[data-step-submit]');
    this.back.addEventListener('click', () => this.go(this.index - 1));
    this.next.addEventListener('click', () => {
      if (this.validate()) this.go(this.index + 1);
    });
    this.go(this.dataset.errors === 'true' ? this.steps.length - 1 : 0, false);
  }

  value(name) {
    const field = this.form.elements[name];
    return field ? field.value || '' : '';
  }

  prefill() {
    const params = new URLSearchParams(window.location.search);
    const service = params.get('service');
    const issue = params.get('issue');
    const select = this.form.elements['contact[Service]'];
    if (service && select) {
      const match = [...select.options].find((option) => option.value === service);
      if (match) select.value = service;
    }
    const message = this.form.elements['contact[body]'];
    if (issue && message && !message.value) message.value = `Fault finder: ${issue}\n`;
  }

  toggleEmergency() {
    const note = this.querySelector('[data-emergency-note]');
    if (note) note.hidden = this.value('contact[Urgency]') !== this.dataset.emergencyValue;
  }

  validate() {
    const fields = [...this.steps[this.index].querySelectorAll('input, select, textarea')];
    for (const field of fields) {
      if (!field.checkValidity()) {
        field.reportValidity();
        return false;
      }
    }
    return true;
  }

  go(index, focus = true) {
    const last = this.steps.length - 1;
    this.index = Math.max(0, Math.min(index, last));
    this.steps.forEach((step, i) => (step.hidden = i !== this.index));
    this.back.hidden = this.index === 0;
    this.next.hidden = this.index === last;
    this.submit.hidden = this.index !== last;
    if (this.counter) this.counter.textContent = `Step ${this.index + 1} of ${this.steps.length}`;
    this.bar.forEach((segment, i) => segment.classList.toggle('is-done', i <= this.index));
    if (focus) {
      const target = this.steps[this.index].querySelector('legend') || this.steps[this.index];
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: false });
    }
  }
}

if (!customElements.get('cf-quote-form')) customElements.define('cf-quote-form', CfQuoteForm);
